import moment from "moment";
export default {
  mixins: [],

  methods: {
    handlerReqInventoryNewItem(item, inventory) {
      //item.metaSearchable -> statusDefault, statusImei, statusBatch
      return {
        currency: "VND",
        locationId: inventory.locationId,
        inventoryIds: [inventory.inventoryId],
        lineItemReqs: inventory.lineItemReqs.map((e, index) => {
          let quantity = this.checkNumReplaceComma(e.quantity);
          let adjusted = e.adjusted != undefined ? this.checkNumReplaceComma(e.adjusted) : quantity;
          
          /*
          const priceItem = item.prices.find(price => price.priceTypeCode === 'PRICE_EXPORT')
          const unitPrice = (priceItem != undefined) ? priceItem.amount : 0
          */
          
          //Gan lai gia
          const exportPrice = this.multiplicationThousand(e.prices.exportPrice)
          const importPrice = this.multiplicationThousand(e.prices.importPrice)
          item.prices.map((k)=>{
            if(k.priceTypeCode == 'PRICE_IMPORT'){
              k.amount = importPrice
            }
            if(k.priceTypeCode == 'PRICE_EXPORT'){
              k.amount = exportPrice
            }
          })

          return {
            lineItemId: item.id,
            reason: e.reason ? e.reason : "",
            reasonKey: e.reasonKey ? e.reasonKey : "RECOUNT",
            adjusted: adjusted,
            afterAdjusted: [0, "0", ""].includes(adjusted)
              ? quantity
              : ["NOTFOUND", "LOST", "BROKEN"].includes(e.reasonKey)
              ? quantity - adjusted
              : ["RETURN", "ADD"].includes(e.reasonKey)
              ? quantity + adjusted
              : ["RECOUNT"].includes(e.reasonKey)
              ? adjusted
              : quantity,
            itemInstance: {
              itemId: item.id,
              itemVariationId: e.itemVariationId,
              category: {
                categoryId: item.category.categoryId,
                name: item.category.name,
                description: item.category.description,
                version: item.category.version,
              },
              name: item.name,
              abbreviation: "",
              images: e.images,
              tags: item.tags,
              description: item.description,
              expiry: item.expiry,
              metaSearchable: item.metaSearchable,
              metaNonSearchable: {},
              metaSignature: "",
              taxes: [],
              moreInformation: {
                heightInCentimeter: 0,
                lengthInCentimeter: 0,
                name: item.variations[index].name,
                options: item.variations[index].options,
                sku: item.variations[index].sku,
                upc: item.variations[index].upc,
                version: item.variations[index].version,
                weightInGram: e.weightInGram,
                widthInCentimeter: 0,
                meta:{
                  name: item.name
                }
              },
              discount: [],
              prices: item.prices,
              unit: item.unit,
              version: item.version,
              warranty: item.warranty,
            },
            expiredAt: new Date(moment().add(100, "years")).toISOString(),
            checkInAt: new Date(Date.now()).toISOString(),
            totalAmount: importPrice * quantity,
            unitPrice: importPrice,
            amount: importPrice * quantity,
            unit: item.unit.name != "" ? item.unit.name : "Cái",
            quantity: quantity,
            lineItemOtherInfo: [
              {
                inventoryId: inventory.inventoryId,
                unitPrice: importPrice,
                quantity:quantity
                //serires: null,
                //batchCode: null,
              }
            ]
          };
        }),
      };
    },
  },
};
